import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import { NavLink } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import val from "../../getThemeDetails";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { adminGetkycActionType } from "../../redux/actions/adminGetKycActionTypeAction";
import { adminGetKycDocumentList } from "../../redux/actions/adminGetKycDocumentListAction";
import { adminAddOrUpdateKycDocument } from "../../redux/actions/adminAddOrUpdateKycDocumentAction";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function AdminCreateDocumentType() {
	const [searchActionType, setSearchActionType] = useState("");
	const [searchDocumentName, setSerchDocumentName] = useState("");

	const [page, setPage] = useState(0);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [addOpen, setAddOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(false);

	const [getKycActionTypeStatus, setGetGetKycActionTypeStatus] =
		useState(false);
	const [getKycActionTypeArray, setGetKycActionTypeArray] = useState([]);

	const [getKycDocumentListStatus, setGetKycDocumentListStatus] =
		useState(false);
	const [getKycDocumentListArray, setGetKycDocumentListArray] = useState([]);

	const [addOrUpdateKycDocumentStatus, setAddOrUpdateKycDocumentStatus] =
		useState(false);
	const [addOrUpdateKycDocumentArray, setAddOrUpdateKycDocumentArray] =
		useState([]);

	const [notificationOpen, setNotificationOpen] = React.useState(false);

	const view = "view";
	const edit = "edit";

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [user, setUser] = useState({
		docId: "",
		docName: "",
		actionType: "",
		description: ""
	});

	const { docId, docName, actionType, description } = user;

	const onInputChange = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...user
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setUser(obj);
	};

	const getKycActionTypeRes = useSelector(
		({ adminGetKycActionType }) => adminGetKycActionType
	);

	const getKycDocumentListRes = useSelector(
		({ adminGetKycDocumentList }) => adminGetKycDocumentList
	);

	const addOrUpdateKycDocumentRes = useSelector(
		({ adminAddOrUpdateKycDocument }) => adminAddOrUpdateKycDocument
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "searchActionType") {
			setSearchActionType(value == "Select Action Type" ? "" : value);
		}
		if (name === "searchDocumentName") {
			// setSerchDocumentName(value);
			Util.verifyAlphabet(value)
				? setSerchDocumentName(value)
				: setSerchDocumentName(searchDocumentName);
		}
	};

	const getKycDocumentListReq = () => {
		setIsLoading(true);
		setGetKycDocumentListStatus(true);
		let req = {
			adminId: val.adminIDS,

			// adminId: 2,
			actionType: searchActionType,
			docName: searchDocumentName
		};
		dispatch(adminGetKycDocumentList(req, authToken));
	};

	const getKycDocumentListFunc = () => {
		if (getKycDocumentListStatus) {
			if (getKycDocumentListRes.data.status == "success") {
				setGetKycDocumentListArray(
					[].concat(getKycDocumentListRes.data.commonKycDetailsList)
				);
				setIsLoading(false);
			}
			if (getKycDocumentListRes.data.status == "failed") {
				setGetKycDocumentListArray(getKycDocumentListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getKycDocumentListRes.data.description
				);
				setIsLoading(false);
				if (
					getKycDocumentListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycDocumentListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getKycDocumentListRes.data.status == "NOT FOUND") {
				setGetKycDocumentListArray(getKycDocumentListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getKycDocumentListRes.data.description
				);
				setIsLoading(false);
			}
		}
	};

	useEffect(() => {
		getKycDocumentListFunc();
	}, [getKycDocumentListRes.data.status]);

	const addOrUpdateKycDocumentReq = () => {
		setAddOrUpdateKycDocumentStatus(true);
		let req = {
			actionType: actionType,
			docName: docName,
			description: description,
			adminId: val.adminIDS,

			// adminId: 2,
			kycId: docId
		};
		dispatch(adminAddOrUpdateKycDocument(req, authToken));
	};

	const addOrUpdateKycDocumentFunc = () => {
		if (addOrUpdateKycDocumentStatus) {
			if (addOrUpdateKycDocumentRes.data.status == "success") {
				setAddOrUpdateKycDocumentArray(addOrUpdateKycDocumentRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
				getKycDocumentListReq();
			}
			if (addOrUpdateKycDocumentRes.data.status == "failed") {
				setAddOrUpdateKycDocumentArray(addOrUpdateKycDocumentRes.data);
				setEditOpen(false);
				setAddOpen(false);
				setNotificationOpen(true);
				if (
					addOrUpdateKycDocumentRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addOrUpdateKycDocumentRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		addOrUpdateKycDocumentFunc();
	}, [addOrUpdateKycDocumentRes.data.status]);

	const getGetKycActionTypeReq = () => {
		setGetGetKycActionTypeStatus(true);
		let req = {
			adminId: val.adminIDS,

			// adminId: 2
		};
		dispatch(adminGetkycActionType(req, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getGetKycActionTypeReq();
			getKycDocumentListReq();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const getGetKycActionTypeFunc = () => {
		if (getKycActionTypeStatus) {
			if (getKycActionTypeRes.data.status == "success") {
				setGetKycActionTypeArray(getKycActionTypeRes.data.currencyList);
			}
			if (getKycActionTypeRes.data.status == "failed") {
				setGetKycActionTypeArray(getKycActionTypeRes.data);
				if (
					getKycActionTypeRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getKycActionTypeRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getGetKycActionTypeFunc();
	}, [getKycActionTypeRes.data.status]);

	const setData = (row, fs) => {
		if (fs == "view") {
			setViewOpen(true);
		}
		if (fs == "edit") {
			setEditOpen(true);
		}
		setUser({
			docId: row.kycId,
			docName: row.username,
			actionType: row.docIdType,
			description: row.description
		});
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setAddOpen(false);
		setUser({
			docId: "",
			docName: "",
			actionType: "",
			description: ""
		});
	};

	const addProofType = () => {
		setAddOpen(true);
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							textAlign: "center"
						}}
					>
						<Grid item md={4} sm={12} lg={9}></Grid>
						<Grid item md={4} sm={12} lg={3}>
							{/* <Button
								variant="contained"
								style={{ backgroundColor: "#00b9f5", color: "white" }}
								size="small"
								onClick={() => addProofType()}
							>
								Add New Doc Type
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={() => addProofType()}
							>
								Add New Doc Type
							</CustomButton>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								type="text"
								label="Action Type"
								variant="standard"
								fullWidth={true}
								name="searchActionType"
								defaultValue={"Select Action Type" || searchActionType}
								onChange={handleChange}
							>
								<MenuItem
									value="Select Action Type"
									selected="Select Action Type"
								>
									Select Action Type
								</MenuItem>
								{getKycActionTypeRes.data.currencyList &&
									getKycActionTypeArray.map((x) => (
										<MenuItem value={x.split("-")[0]}>
											{x.split("-")[0]}
										</MenuItem>
									))}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							<TextField
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Document Name"
								fullWidth={true}
								name="searchDocumentName"
								value={searchDocumentName || ""}
								onChange={handleChange}
							></TextField>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={4}>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getKycDocumentListReq}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getKycDocumentListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getKycDocumentListArray.length == undefined ||
					getKycDocumentListArray.status == "NOT FOUND" ||
					!getKycDocumentListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography variant="body1" style={{ fontWeight: "700" }}
									className="themeText"

								>
									Report Table
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Document ID
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Document Name
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action Type
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Description
											</TableCell>
											<TableCell
												colSpan={2}
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getKycDocumentListArray &&
											[]
												.concat(getKycDocumentListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow>
														<TableCell align="center">{row.kycId}</TableCell>
														<TableCell align="center">{row.username}</TableCell>
														<TableCell align="center">
															{row.docIdType}
														</TableCell>
														<TableCell align="center">
															{row.description}
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, view)}
															>
																<VisibilityIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
														<TableCell align="center">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() => setData(row, edit)}
															>
																<EditIcon style={{ color: "#fff" }} />
															</CustomButton>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getKycDocumentListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={viewOpen} onClose={handleClose}>
						<DialogTitle>View Proof Type</DialogTitle>
						<DialogContent>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"
								label="Document ID"
								fullWidth={true}
								name="docId"
								value={docId || ""}
							></TextField>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Document Name"
								fullWidth={true}
								name="docName"
								value={docName || ""}
							></TextField>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Action Type"
								fullWidth={true}
								name="actionType"
								value={actionType || ""}
							></TextField>
							<TextField
								disabled
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Description"
								fullWidth={true}
								name="description"
								value={description || ""}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Close
							</Button>
						</DialogActions>
					</Dialog>
				</div>
				<div>
					<Dialog open={editOpen} onClose={handleClose}>
						<DialogTitle>Edit Proof Type</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Document Name"
								variant="standard"
								fullWidth={true}
								name="docName"
								value={docName || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
							<TextField
								required
								select
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								variant="standard"

								label="Action Type"
								fullWidth={true}
								name="actionType"
								value={actionType || "Select Action Type"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Action Type"
									selected="Select Action Type"
								>
									Select Action Type
								</MenuItem>
								{getKycActionTypeRes.data.currencyList &&
									getKycActionTypeArray.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								type="text"
								label="Description"
								fullWidth={true}
								name="description"
								defaultValue={description || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateKycDocumentReq}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>

				<div>
					<Dialog open={addOpen} onClose={handleClose}>
						<DialogTitle style={{ minWidth: "600px" }}>
							Add Proof Type
						</DialogTitle>
						<DialogContent>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Document Name"
								fullWidth={true}
								name="docName"
								variant="standard"
								value={docName || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
							<TextField
								required
								select
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Action Type"
								fullWidth={true}
								variant="standard"

								name="actionType"
								defaultValue={actionType || "Select Action Type"}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem
									value="Select Action Type"
									selected="Select Action Type"
								>
									Select Action Type
								</MenuItem>
								{getKycActionTypeRes.data.currencyList &&
									getKycActionTypeArray.map((x) => (
										<MenuItem value={x}>{x}</MenuItem>
									))}
							</TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								type="text"
								label="Description"
								variant="standard"

								fullWidth={true}
								name="description"
								defaultValue={description || ""}
								// onChange={(e) => onInputChange(e)}
								onChange={(e) => onInputChange(e, "alphabet")}
							></TextField>
						</DialogContent>
						<DialogActions style={{ padding: "14px" }}>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							<Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={addOrUpdateKycDocumentReq}
							>
								Save
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{addOrUpdateKycDocumentArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateKycDocumentArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addOrUpdateKycDocumentArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c", width: "255px" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{addOrUpdateKycDocumentArray.description.split("|").map((x) => (
									<p style={{ margin: "3px" }}>{x}</p>
								))}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									marginBottom: "10px",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default AdminCreateDocumentType;
